import { render } from "./TechnoFrame.vue?vue&type=template&id=5be7c577&scoped=true&ts=true"
import script from "./TechnoFrame.vue?vue&type=script&lang=ts"
export * from "./TechnoFrame.vue?vue&type=script&lang=ts"

import "./TechnoFrame.vue?vue&type=style&index=0&id=5be7c577&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be7c577"]])

export default __exports__